import { IsEmptyString } from "../Components/GeneralFunctions.jsx"

export function CallData(call) 
{
    let Response = {}
    if (call != null)
    {
        Response.id = call.CallId ?? ""
        Response.inbound = (call.Direction ?? "").toLowerCase() === "inbound"
        Response.opn = Response.inbound ? (call?.CallerNumber ?? "") : (call?.CalledNumber ?? "")  
        Response.ddi = Response.inbound ? (call.CalledNumber ?? "") : "" 
        Response.ddiname = Response.inbound ? (call.CalledName ?? "") : ""
        Response.extension = call.DeviceNumber ?? ""
        Response.state = call.State ?? ""
        try { Response.starttime = !IsEmptyString(call?.StartTime) ? parseInt(call.StartTime,10) : null } catch {}
        try { Response.answeredtime = !IsEmptyString(call?.AnswerTime) ? parseInt(call.AnswerTime,10) : null } catch {}
        try { Response.endedtime = !IsEmptyString(call?.EndTime) ? parseInt(call.EndTime,10) : null } catch {}
    }
    return Response
}

export function EmbeddedGetEmbeddedRecognition() {
    try { return JSON.parse(localStorage.getItem("embedded_lastcallrecognition")) } catch { return null }
}

export function EmbeddedSetEmbeddedRecognition(value) {
    localStorage.setItem("embedded_lastcallrecognition", value)
}

export function EmbeddedGetEmbeddedRecognitionSelectedIndex() {
    return parseInt(localStorage.getItem("embedded_lastcallselectedrecognitionindex") ?? 0)
}

export function EmbeddedSetEmbeddedRecognitionSelectedIndex(value) {
    localStorage.setItem("embedded_lastcallselectedrecognitionindex", value)
}